import { Box, Typography, Slider } from "@mui/material";
import useTranslationSetup from "../../utils/useTranslationSetup";
import SubjectTag from "../subjectTag/SubjectTag";
import "./styles.css";

const SliderWithLabel = ({
  min,
  max,
  step,
  defaultValue,
  marks,
  valueLabelDisplay,
  label,
  setSliderValue = () => {},
}) => {
  const { activeLanguage } = useTranslationSetup();

  const handleSliderChange = (event, newValue) => {
    setSliderValue(newValue);
  };
  const valuetext = (value) => {
    return `${value}`;
  };

  return (
    <Box className="slider-with-label-container">
      <div className="subject-tag-wrapper">
        <SubjectTag />
      </div>
      <div className="text-size">
        <Typography
          fontSize="16px"
          lang={activeLanguage}
          fontFamily="poppins-regular"
        >
          {label}
        </Typography>
      </div>
      <div className="text-resize-slider">
        <Slider
          aria-label="Temperature"
          value={defaultValue || 0}
          getAriaValueText={valuetext}
          valueLabelDisplay={valueLabelDisplay}
          step={step || 1}
          marks={marks}
          min={min || 0}
          max={max || 0}
          onChange={handleSliderChange}
          className="custom-slider"
        />
      </div>
    </Box>
  );
};

export default SliderWithLabel;
